<script setup lang="ts">
import { computed, provide } from 'vue';
import { RouterView, useRoute } from 'vue-router';
import UiFullscreenLayout from '@krafta/ui-kit/components/UiFullscreenLayout.vue';
import AppNotificationsHost from '@app/components/AppNotificationsHost.vue';
import AuthenticatedLayout from '@app/layouts/AuthenticatedLayout.vue';
import PublicLayout from '@app/layouts/PublicLayout.vue';
import { useAuthStore } from '@app/stores/auth';
import { useTheme } from '@shared/composables/useTheme';
import { themeInjectionKey } from '@shared/context/injectionKeys';

const auth = useAuthStore();
const route = useRoute();
const theme = useTheme();

provide(themeInjectionKey, theme);

const isFullscreenLayout = computed(
  () =>
    (route.meta.layoutVariant === 'kiosk' || route.meta.layoutVariant === 'fullscreen') &&
    (Boolean(auth.user) || route.meta.terminal === true)
);
const layoutComponent = computed(() =>
  route.meta.public || !auth.user ? PublicLayout : AuthenticatedLayout
);
const canRenderRoute = computed(() => route.meta.public === true || auth.isAuthenticated);
</script>

<template>
  <AppNotificationsHost />
  <UiFullscreenLayout v-if="isFullscreenLayout">
    <RouterView v-if="canRenderRoute" />
  </UiFullscreenLayout>
  <component
    :is="layoutComponent"
    v-else
    :theme="theme"
  >
    <RouterView v-if="canRenderRoute" />
  </component>
</template>
